<div class="w-[337px] bg-surface-enabled-primary shadow border border-stroke-enabled rounded-[8px] p-[16px] mt-[8px]">

  <!-- Header menu -->
  <div class="flex items-start gap-[16px] mb-[16px] relative">
    @if (!isAlternativeAvatar) {
      <img
        class="w-[62px] h-auto rounded-[8px] border-[3px] border-[#FBBB21]"
        [src]="avatar"
        alt="Avatar de usuário logado"
      >
    } @else {
      <div class="flex items-center justify-center text-[16px] font-medium w-[52px] h-[52px] rounded-[8px] border-[3px] text-text-invese border-[#FBBB21] bg-[#005B87]">
        {{initialsName}}
      </div>
    }

    <div class="flex flex-col gap-[6px]">
      <span class="text-[14px] text-text-default font-semibold">{{ userData.nome }}</span>
      <p class="text-[12px] text-text-default">{{userData.email}}</p>
      <p class="text-[12px] text-text-default font-semibold">{{userData.grupoPermissoesUsuario.nome}}</p>
    </div>

    <button class="absolute top-0 right-0" (click)="openModalAbout()">
      <ng-icon name="heroInformationCircleSolid" size="20px" color="#4B5563"></ng-icon>
    </button>
  </div>

  <!-- Lista Menu -->
  <ul class="flex flex-col py-[8px] border-t-2 border-b-2 border-stroke-enabled cursor-pointer">
    <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" routerLink="/perfil-usuario" cdkMenuItem>
      <ng-icon name="heroUserCircleSolid" size="20px"></ng-icon>
      Perfil
    </li>
    @if(isUserAdmin){
        <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" routerLink="/config-corretora" cdkMenuItem
          >
          <ng-icon name="heroBriefcaseSolid" size="20px"></ng-icon>
          Dados da corretora
        </li>

        <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" routerLink="/meu-plano" cdkMenuItem
          >
          <ng-icon name="heroCreditCardSolid" size="20px"></ng-icon>
          Meu plano
        </li>
    }
    @if (userData.root) {
      <div class="border-1 border-stroke-enabled my-[8px]"></div>

      <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" routerLink="/corretoras" cdkMenuItem>
        <ng-icon name="heroBriefcaseSolid" size="20px"></ng-icon>
        Painel administrativo
      </li>

      <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" routerLink="/painel-notificacoes" cdkMenuItem>
        <ng-icon name="heroBellSolid" size="20px"></ng-icon>
        Painel notificações
      </li>
    }

    <div class="border-1 border-stroke-enabled my-[8px]"></div>

    <span class="text-text-enabled text-[14px] p-[8px]">Suporte</span>

    <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" routerLink="/atendimento-ia" cdkMenuItem
      *showIfAuthorized="true">
      <ng-icon name="chatbot-speech-bubble" size="20px"></ng-icon>
      Atendimento instantâneo
    </li>

    <li class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" (click)="redirectToCentral()" cdkMenuItem
      *showIfAuthorized="'SUPORTE'">
      <ng-icon name="faceAgentOutline" size="20px"></ng-icon>
      Atendimento humanizado
    </li>

    <li cdkMenuItem>
      <a class="flex items-center gap-[8px] text-text-interactive font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2]" (click)="downloadTeamViewer()">
        <ng-icon name="teamViewer" size="20px"></ng-icon>
        Acesso remoto
      </a>
    </li>
  </ul>

  <!-- Action -->
  <div class="mt-[8px]" cdkMenuItem>
    <button class="flex items-center gap-[8px] text-text-error font-semibold transition rounded p-[8px] hover:bg-[#F2F2F2] w-full" (click)="logoutEventEmitter()">
     <!-- Icon -->
      <ng-icon name="heroArrowLeftStartOnRectangle" size="20px"></ng-icon>
     Sair
   </button>
  </div>
</div>
